import { lazy, Suspense } from 'react'; 
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Contacts from './components/Contacts';
import KinoTheater from './components/KinoTheater';
import Schriftstellerei from './components/Schriftstellerei';
import SohnLuzifersKTL from './components/SohnLuzifersKTL';
import SohnLuzifers from './components/SohnLuzifers';
import Tagebucher from './components/Tagebucher';
import Drehbuch from './components/Drehbuch';
import Lieder from './components/Lieder';
import Woche from './components/Woche';
import Gefangnis from './components/Gefangnis';
import Zombi from './components/Zombi';
import Gedichte from './components/Gedichte';
import GedichteKTL from './components/GedichteKTL';
import Krug from './components/Krug';
import Ideology from './components/Ideology';

const LK = lazy(() => import('./components/LK'));
const News = lazy(() => import('./components/News'));
const Auslandsamt = lazy(() => import('./components/Auslandsamt'));

const Seite = lazy(() => import('./components/Seite'));
const Krug13 = lazy(() => import('./components/Krug/Krug13'));
const IdeologyK = lazy(() => import('./components/IdeologyK'));
const SearchResults = lazy(() => import('./components/SearchResults'));
const Favoriten = lazy(() => import('./components/Favoriten'));

const Jack = lazy(() => import('./components/SohnLuzifers/Jack'));
const Anfang = lazy(() => import('./components/SohnLuzifers/Anfang'));
const Gefangnistagebucher = lazy(() => import('./components/Gefangnis/Gefangnistagebucher'));
const Zweiundvierzig = lazy(() => import('./components/Gefangnis/Zweiundvierzig'));
const Karzer = lazy(() => import('./components/Gefangnis/Karzer'));
const Gazprom = lazy(() => import('./components/Gefangnis/Gazprom'));
const Zombi1 = lazy(() => import('./components/Zombi/Zombi1'));
const Zombi2 = lazy(() => import('./components/Zombi/Zombi2'));
const Zombi3 = lazy(() => import('./components/Zombi/Zombi3'));

const generateRoutes = () => {
  const files = {
    ...import.meta.glob("./components/Gedichte/Gedicht*.tsx"),
    ...import.meta.glob("./components/SohnLuzifers/Tag*.tsx"),
    ...import.meta.glob("./components/Tagebucher/Tagebuch*.tsx"),
    ...import.meta.glob("./components/Drehbuch/Szenarium*.tsx"),
    ...import.meta.glob("./components/Lieder/Lied*.tsx"),
    ...import.meta.glob("./components/Woche/Zeitung*.tsx"),
    ...import.meta.glob("./components/SohnLuzifersKTL/KTLTag*.tsx"),
    ...import.meta.glob("./components/GedichteKTL/KTLGedicht*.tsx"),
    ...import.meta.glob("./components/News/News*.tsx"),
    ...import.meta.glob("./components/Auslandsamt/Post*.tsx"),
  };

  return Object.keys(files).map((filePath) => {
    const match = filePath.match(/components\/([^/]+)\/([^/]+)\.tsx$/);
    if (!match) return null;

    const [, folder, fileName] = match;
    let routePath;
    if (folder === "SohnLuzifersKTL") {
      routePath = `/kinotheater/sohnluzifers/${fileName.toLowerCase()}`;
    } else if (folder === "GedichteKTL") {
      routePath = `/kinotheater/gedichte/${fileName.toLowerCase()}`;
    } else if (["Gedichte", "SohnLuzifers", "Tagebucher", "Drehbuch", "Gefangnis", "Lieder", "Woche"].includes(folder)) {
      routePath = `/schriftstellerei/${folder.toLowerCase()}/${fileName.toLowerCase()}`;
    } else {
      routePath = `/${folder.toLowerCase()}/${fileName.toLowerCase()}`;
    }

    
    const Component = lazy(() =>
      files[filePath]().then((module) => ({
        default: (module as { default: React.ComponentType }).default,
      }))
    );

    return <Route key={routePath} path={routePath} element={<Component />} />;
  }).filter(Boolean);
};

const App: React.FC = () => {
  return (      
    <div id="body">
      <Suspense fallback={<div>...</div>}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Seite />} />
            <Route path="news" element={<News />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="schriftstellerei" element={<Schriftstellerei />} />
            <Route path="/schriftstellerei/sohnluzifers" element={<SohnLuzifers />} />
            <Route path="/schriftstellerei/sohnluzifers/jack" element={<Jack />} />
            <Route path="/schriftstellerei/sohnluzifers/anfang" element={<Anfang />} />
            <Route path="/schriftstellerei/gedichte" element={<Gedichte />} />
            <Route path="/schriftstellerei/tagebucher" element={<Tagebucher />} />
            <Route path="/schriftstellerei/drehbuch" element={<Drehbuch />} />
            <Route path="/schriftstellerei/gefangnis" element={<Gefangnis />} />
            <Route path="/schriftstellerei/gefangnis/gefangnistagebucher" element={<Gefangnistagebucher />} />
            <Route path="/schriftstellerei/gefangnis/karzer" element={<Karzer />} />
            <Route path="/schriftstellerei/gefangnis/zweiundvierzig" element={<Zweiundvierzig />} />
            <Route path="/schriftstellerei/gefangnis/gazprom" element={<Gazprom />} />
            <Route path="/schriftstellerei/lieder" element={<Lieder />} />
            <Route path="ideology" element={<Ideology />} />
            <Route path="/ideology/kodex" element={<IdeologyK />} />
            <Route path="/lk" element={<LK />} />
            <Route path="/schriftstellerei/woche" element={<Woche />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="kinotheater" element={<KinoTheater />} />
            <Route path="/kinotheater/zombi" element={<Zombi />} />
            <Route path="/kinotheater/zombi/zombi1" element={<Zombi1 />} />
            <Route path="/kinotheater/zombi/zombi2" element={<Zombi2 />} />
            <Route path="/kinotheater/zombi/zombi3" element={<Zombi3 />} />
            <Route path="/kinotheater/sohnluzifers" element={<SohnLuzifersKTL />} />
            <Route path="/auslandsamt" element={<Auslandsamt />} />
            <Route path="/kinotheater/gedichte" element={<GedichteKTL />} />
            <Route path="privacy" element={<Krug />} />
            <Route path="terms" element={<Krug13 />} />
            <Route path="/lk/favoriten" element={<Favoriten />} />
            {generateRoutes()}
          </Route>
        </Routes>
      </Suspense>
    </div>
  );
};

export default App;